var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dynamic-master-layout',[_c('WebsiteFaqs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }